class HeroAnimation {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getHeroImage() {
    let element = this.getElement();
    return element.querySelector('.js-heroImage');
  }

  getText() {
    let element = this.getElement();
    return element.querySelector('.js-heroText');
  }

  getAnimation() {
    let element = this.getElement();
    return element.querySelector('.js-animation');
  }

  setTextAnimation() {
    let textEl = this.getText();
    let animationEl = this.getAnimation();
    let options = {
      threshold: 0
    }
    
    const observer = new IntersectionObserver((entries, options) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
        } 
        else {
          textEl.classList.add("active");
          animationEl.style.opacity = "0";
          setTimeout(() => {
            animationEl.style.display = "none";
          },300);
        }
      });
    }, options);

    setTimeout(() => {
      observer.observe(textEl);
    },200)
  }

  setEventHandlers() {
    this.setTextAnimation();
  }

  init() {
    this.setEventHandlers();
  }
}


const HeroAnimationInit = {
  init() {
    const $el = document.querySelector(".js-hero");
    if ($el) {
      new HeroAnimation($el);
    }
  },
};


export default HeroAnimationInit;
